import { createFileRoute } from "@tanstack/react-router";
import { TutorCabinetPage } from "@/components/partners/TutorCabinetPage";
import { tutorCabinetHead } from "@/components/partners/tutor-cabinet-head";

// Кабинет репетитора (en): вход по ссылке из письма, правка анкеты, пауза, удаление.
// noindex, в sitemap нет (src/lib/partner-cabinet.ts).
export const Route = createFileRoute("/en/tutors/me")({
  head: () => tutorCabinetHead("en"),
  component: () => <TutorCabinetPage lang="en" />,
});
